/**
=========================================================
* Soft UI Dashboard React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import axios from 'axios';  
import React from 'react';  
import { useLocation, Link } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";
// @mui material components
import Card from "@mui/material/Card";
import SoftInput from "components/SoftInput";
import { Calendar } from 'primereact/calendar'; // Import Calendar for date selection


// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { Helmet } from "react-helmet";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button as ButtonP }  from 'primereact/button';
import { InputText as pText } from 'primereact/inputtext';
import { FilterMatchMode } from 'primereact/api';
import { Toolbar } from 'primereact/toolbar';
import { exportCSV } from 'primereact/utils';

// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import {useEffect, useState, useRef} from 'react';
//import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import FormSelect from 'react-bootstrap/FormSelect';
import {getPlayerProfile} from 'Utils.js'
import gr_logo from "assets/images/group.png";

import jsPDF from 'jspdf';
import 'jspdf-autotable';

// Data
//import membersTableData from "layouts/groups/data/membersTableData";

import SoftAvatar from "components/SoftAvatar";
import SoftBadge from "components/SoftBadge";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";
import { Navigate } from "react-router-dom";
import SoftButton from "components/SoftButton";
import Modal from 'react-modal';

import whatsapp_logo from "assets/images/logos/whatsapp.png";
import telegram_logo from "assets/images/logos/telegram.png";
import { FaMinusCircle } from "react-icons/fa";
import { FaPenSquare } from "react-icons/fa";
import { FaBackward } from "react-icons/fa";
import { FaForward } from "react-icons/fa";
import { FaImages } from "react-icons/fa";

import { alertTitleClasses } from '@mui/material';

import 'primereact/resources/themes/lara-light-indigo/theme.css';  
import 'primereact/resources/primereact.min.css';                  
import 'primeicons/primeicons.css';                                
import 'primeflex/primeflex.css';     

import { FaSyncAlt, FaSync, FaBan } from 'react-icons/fa'; // FaSyncAlt = refresh


const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
  overlay: {zIndex: 100000}   
};


function Author({ image, name, email }) {
  return (
    <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
      <SoftBox mr={2}>
        <SoftAvatar src={image} alt={name} size="sm" variant="rounded" />
      </SoftBox>
      <SoftBox display="flex" flexDirection="column" >
        <SoftTypography variant="button" fontWeight="medium" color="info">
          {name}
        </SoftTypography>
        <SoftTypography variant="caption" color="secondary">
          {email}
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
};
function Function({ job, org }) {
  return (
    <SoftBox display="flex" flexDirection="column">
      <SoftTypography variant="caption" fontWeight="medium" color="text">
        {job}
      </SoftTypography>
      <SoftTypography variant="caption" color="secondary">
        {org}
      </SoftTypography>
    </SoftBox>
  );
};
let global_group_id='';
export default class Resend extends React.Component {  
  constructor(props) {
    super(props);
    this.setState({loggedIn: '1'});
    this.setState({showModal: false,isChecked:false});

    const today = new Date();
    const threeMonthsBack = new Date();
    threeMonthsBack.setMonth(today.getMonth() - 3);
    
    
    window.helloComponent = this;

    
    this.state = { data: [],
      loading: true,loggedIn: '1',
      globalFilter: '',  // Search box filter
            filters: {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
            },
            fromDate: threeMonthsBack,  // Default from date
            toDate: today ,
            first: 0,  // Track current page to calculate Sl No
            rows: 10 ,
            showModal: false,viewstatus:'list',linkrows:[],group_logo:team2,groupname:'Cricket Group',group_normal_count: 14, group_guest_count : 2};

    let search = window.location.search;
    let params = new URLSearchParams(search);

     global_group_id = params.get('id')
    if(global_group_id==null)
    {
      global_group_id=  '';
    }


    let sid = params.get('sid')
    if(sid==null)
    {
      sid=  '';
    }
    let series_id = '';
    if(sid!=''){
      series_id = atob(sid);
    }

    let csid = params.get('csid')
    if(csid==null)
    {
      csid=  '';
    }
    let cseries_id = '';
    if(csid!=''){
      cseries_id = atob(csid);
    }
    if(series_id  !='')
    {
     
      setTimeout(
        () => this.setState({viewstatus: 'createlink'}), 
        1500
      );
      //this.setState({viewstatus: 'createlink'});
    }else if(cseries_id !=  '')
    {
      setTimeout(
        () => this.setState({viewstatus: 'createlink'}), 
        1500
      );
    }
    this.dt = React.createRef();
      
//    this.setState({linkData:{rows:[]}});

  this.ref_link_heading = React.createRef();

  this.ref_link_heading_link = React.createRef();
    
  }
  state = {  
    normalmembers: []  ,
    guestmembers:[]

  }  

  


onGlobalFilterChange = (e) => {
  const value = e.target.value;  // Get the typed value
  this.setState({
      globalFilter: value,  // Update the state
      filters: { 'global': { value, matchMode: FilterMatchMode.CONTAINS } }
  });
};

// Export Data as CSV
exportCSV = () => {
  this.dt.current.exportCSV();
};

exportPDF = () => {
  const doc = new jsPDF();
  const exportData = this.state.filteredData || this.state.data;

  doc.autoTable({
      head: [['Sl No', 'Name', 'Mobile No', 'No.of Matches', 'Type', 'Last Match', 'First Match', 'Days Gap']],  // Table header
      body: exportData.map((item ,index) => [index+1, item.full_name,item.mobile_no, item.no_of_times, item.member, item.last_match_date, item.first_match_date, item.days_gap]),  // Table body
  });
  doc.save('Resend-data.pdf');  // Save the PDF
};

noOfTimesTemplate = (rowData) => {
  if(rowData.member === 'Guest')
  {

  
  const style = (rowData.member === 'Guest' && rowData.no_of_times >= 3) 
      ? { backgroundColor: '#0ced6a', color: '#cc0000', fontWeight: 'bold' } // Custom styling
      : {};

  return (
      <span style={style}>
          {rowData.no_of_times}
      </span>
  );
  }else
  {
    const style = (rowData.member === 'Normal' && rowData.no_of_times == 0) 
      ? { color: '#cc0000', fontWeight: 'bold' } // Custom styling
      : {};

  return (
      <span style={style}>
          {rowData.no_of_times}
      </span>
  );
  }
};


toolbarTemplate = () => (
  <div className="p-d-flex p-jc-between">

    {/* Date Input Section */}
    <div className="p-d-flex p-jc-between p-ai-center p-mb-4 p-flex-wrap">
                   
                    <div className="mb-4">
                    <ButtonP 
                        label="Refresh" 
                        icon="pi pi-check" 
                        className="p-button-primary" 
                        onClick={this.handleRetrieve} 
                    />
                    </div>
                </div>

      <div>
          <ButtonP
              label="Export CSV" 
              icon="pi pi-file" 
              className="p-button-success p-mr-2" 
              onClick={this.exportCSV} 
          />

<ButtonP
                        label="Export PDF"
                        icon="pi pi-file-pdf"
                        className="p-button-danger"
                        onClick={this.exportPDF}
                    />

      </div>
  </div>
);

  componentDidMount() { 
      /*
    axios.get(global.config.app.backend_api_url +`groups/setsession?user_id=2`, { withCredentials: true })//, { withCredentials: true }  
      .then(res => {  

      });*/
      const post_data1 = { lo : 1};

      axios.post( global.config.app.backend_api_url + `login/sessionavailable`,post_data1, { withCredentials: true }
      )  
        .then(res => {  
          console.log(res.data)
          var user_id = res.data.user_details.user_id;
          
          if (user_id !== undefined && user_id !== null && user_id !== 'null') 
          {

            
          }else
          {
            window.location.replace('sign-in');
            //return;
          }

          if(res.data.user_details.user_id!='')
          {
           // this.callNotificationSubscribe(res.data.user_details.nai,res.data.user_details.user_id);
          }
    
        });

       

        
       // this.callbasicapi();
        this.fetchData();
        
      
  }  

  handleRetrieve = () => {
    // Call fetchData with the selected dates when Retrieve is clicked
    this.fetchData();
};

onPageChange = (event) => {
  this.setState({ first: event.first, rows: event.rows });
};

onFilter = (e) => {
  this.setState({ filteredData: e.filteredValue });
};



slNoTemplate = (rowData, options) => {
  const { first, rows } = this.state;
  return <span>{first + options.rowIndex + 1}</span>;
};


  fetchData = () => {
    // Format the dates to be used in the API call (if required)
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let group_id = atob(params.get('id'));
    
    const post_data = { series_id:group_id};

    this.setState({ loading: true }); // Show loader

    // Replace this with your axios.get logic using fromDate and toDate
    
    axios.post( global.config.app.backend_api_url + `auction/getwhatsapp_messages`,post_data, { withCredentials: true }
    )  
        .then(response => {
          if(response.data.status==='0')
          {
            alert(response.data.message);
            this.setState({ loading: false }); // Show loader

            return;
          }
            this.setState({ data: response.data.message_data,loading:false });
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
};



  callbasicapi()
  {
    let search = window.location.search;
      let params = new URLSearchParams(search);
      let series_id = atob(params.get('id'));



    
      const post_data = { series_id: series_id };
      
    // alert(group_id)
//,{headers: {"Content-Type": "application/json"}}
    axios.post( global.config.app.backend_api_url + `auction/get_series_details`,post_data, { withCredentials: true }
    )  
      .then(res => {  
        //const normalmembers = res.data;  
        console.log("after112d")
        console.log(res.data.group_data)
//        alert(res.data.group_data[0].is_admin)
        this.setState( {group_logo: res.data.group_data[0].group_logo,groupname:res.data.group_data[0].series_name,group_normal_count: res.data.group_data[0].normal_members_count, group_guest_count : res.data.group_data[0].guest_members_count,group_admin_flag : res.data.group_data[0].is_admin});

        const normalmembers = this.createMemberRows(res.data.normal_members);
        console.log("getting response "+res.data.normal_members)
        //this.setState({ normalmembers });  

        const guestmembers = this.createMemberRows(res.data.guest_members);
        console.log("getting response ")
        this.setState({ normalmembers,guestmembers,series_notification_type: res.data.series_notification_type});  

       // series_notification_type


        

      });
      

  }
    
  
  


  render() {  

    const handleClose = () => {
      this.setState({showModal: false});
    }
    const handleShow = () => {
      this.setState({showModal: true});
    }

    if(this.state.loggedIn!=='1')
    {
      return <Navigate to="/sign-in" />
  
    };


    const handleActionClick = (wdata) => {
      console.log('Clicked WA MSG ID:', wdata);
      //alert(wdata.wa_ref_no)
      const post_data = { series_id:wdata.wa_ref_no,wa_msg_id: wdata.wa_msg_id ,avoid_media:'0'};

      axios.post( global.config.app.backend_api_url + `auction/update_whatsapp_resend_status`,post_data, { withCredentials: true }
        )  .then(response => {
              console.log('Success:', response.data.message);
              alert(response.data.message)
              // Optionally show a toast or update UI
          })
          .catch(error => {
              console.error('Error:', error);
              alert(error)
              // Optionally handle errors here
          });
  };

  const handleActionClickMedia = (wdata) => {
    console.log('Clicked WA MSG ID:', wdata);
      //alert(wdata.wa_ref_no)
      const post_data = { series_id:wdata.wa_ref_no,wa_msg_id: wdata.wa_msg_id ,avoid_media:'1'};

      axios.post( global.config.app.backend_api_url + `auction/update_whatsapp_resend_status`,post_data, { withCredentials: true }
        )  .then(response => {
              console.log('Success:', response.data.message);
              alert(response.data.message)
              // Optionally show a toast or update UI
          })
          .catch(error => {
              console.error('Error:', error);
              alert(error)
              // Optionally handle errors here
          });
};



  const actionBodyTemplate = (rowData) => {
      return (
        <>
          <Button
              onClick={() => handleActionClick(rowData)}
          ><FaSyncAlt style={{ marginRight: 5 }} /></Button>

         
          </>

      );
  };
  const actionBodyTemplateMedia = (rowData) => {
    return (
      <>
        <div style={{ position: 'relative' }}
         onClick={() => handleActionClickMedia(rowData)}
        >
                <FaSync size={24} />
                
            </div>
        
        

       
        </>

    );
};




  const { fromDate, toDate } = this.state;  // Destructure state data


  //const [list, setList] = useState([]);
  //const [actuallist, setActuallist] = useState([]);

    console.log("sess_data:");  
    console.log(this.state.loggedIn);  

    let link_to_schedules = "/schedules";

    let search1 = window.location.search;
    let params1 = new URLSearchParams(search1);
    let group_id1 = atob(params1.get('id'));
    
    let querystring1 = "?g="+btoa(group_id1);

    const { data, loading, filters } = this.state;

    return (  
      <DashboardLayout>
      <Helmet>
      <title>Group Members | {global.config.app.name}</title>
      <meta
        name="description"
    content="Join Our Cricket Team - Experience the thrill of competitive cricket and be part of a supportive community. Sign up now and showcase your skills on the field."
      />
      <meta
        name="keywords"
        content="Cricket, team, join, competitive, skills, community, sign up, field"
      />
    </Helmet>
      <DashboardNavbar />
      <SoftBox py={3}>
      <Card>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3}>

            <SoftAvatar
              src={this.state.group_logo ? (this.state.group_logo):(gr_logo)}
              alt="profile-image"
              variant="rounded"
              size="xl"
              shadow="sm"
            />

              {this.state.groupname} 

              <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
              {
                (() => {
                  let search = window.location.search;
                    let params = new URLSearchParams(search);
                    let group_id = atob(params.get('id'));

                    

                  if(this.state.group_admin_flag == '1' ){ 

                 // var link_to_create = "/creatematchlink?group_id="+btoa(group_id);


                  let search = window.location.search;
                  let params = new URLSearchParams(search);
                  let series_id ='';
                  let c_series_id ='';
                  if(params.get('sid')!=null)
                  {
                    series_id = atob(params.get('sid'));
                  }
                  if(params.get('csid')!=null)
                  {
                    c_series_id = atob(params.get('csid'));
                  }

                  
                  
                  var caption_cl = 'Generate new match schedule link';
                  if(series_id!='')
                  {
                    caption_cl = 'Edit match link';
                  }/*else if(c_series_id!='')
                  {
                    caption_cl = 'Copy and generate a new match link';
                  }*/
                  
                  


                   return (

      
                    <SoftButton variant="gradient" size="small" color="info"  onClick={() => this.setState({viewstatus: 'createlink'})}>
                    {caption_cl}
              </SoftButton>
                    
                   )
                   }
                  })()
        
                }
             
             
              </SoftBox>

              </SoftBox>
              
              

      </Card>
      <SoftBox py={3}>
      
      <Link to="/groups">
                
                <SoftTypography
                  variant="button"
                  fontWeight="medium"
                  color="dark"
                  onClick={() => this.setState({viewstatus: 'list'})}
                >
                  <FaBackward></FaBackward> Back
                </SoftTypography>
              
            </Link>
            
            
      </SoftBox>
        <SoftBox mb={3}>
        <Toolbar className="p-mb-4" left={this.toolbarTemplate}></Toolbar>

        {/* Loader Section */}
        {this.state.loading ? (
                    <div className="p-d-flex p-jc-center p-mt-4">
                        <ProgressSpinner />
                    </div>
                ) : (
                  <>
                  

                  <DataTable 
                            value={data} 
                            paginator 
                            stripedRows
                            scrollable
                            rows={10} 
                            first={this.state.first} 
                            filterDisplay="row" 
                            onPage={this.onPageChange}
                            //onFilter={this.onFilter}
                            responsiveLayout="scroll" 
                            ref={this.dt}
                            showGridlines 
                            tableStyle={{ minWidth: '50rem', userSelect: 'text' }}
                        >

<Column 
                        header="Sl No" 
                        field="sl"
                        body={this.slNoTemplate} 
                        style={{ width: '80px' }} 
                    />

                            <Column  field="wa_msg_id" style={{ userSelect: 'text' }} header="ID" sortable filter filterPlaceholder="Search by ID" ></Column>
                            <Column   field="msg" style={{ userSelect: 'text' }} header="Message" sortable filter filterPlaceholder="Search by Message" ></Column>
                            <Column   field="image_or_doc_url" style={{ userSelect: 'text' }} header="File URL" sortable filter filterPlaceholder="Search by URL" ></Column>
                            <Column field="add_date" header="Add Time" sortable filter filterPlaceholder="Search by Time" ></Column>
                            <Column body={actionBodyTemplate} header="Resend" style={{ width: '120px' }} />
                            <Column body={actionBodyTemplateMedia} header="Resend without media" style={{ width: '120px' }} />

                        </DataTable>

                    </>
                )}


        {
                (() => {
                  if(this.state.viewstatus === 'list' ){ 
                   return (
          <></>
        )}
        
        

        
      })()
        
        }
        </SoftBox>
        
      </SoftBox>
      
      

      <Footer />
      
    </DashboardLayout>
    )  
  }  
}  

